import React, { useEffect, useState, useContext } from 'react'
import { AppContext } from '../../../App'
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'
import imageProfil from '../../../images/imageprofil.png'
import Spinner from '../../../components.js/elements/Spinner'
import useFirebase from './../../../firebase/useFirebase'
import useForm from '../../../hooks/useForm'
import ButtonShadow from './../../../components.js/elements/ButtonShadow';

const INITIAL_STATE = {
    nomEntreprise:'',
    telephoneEntreprise:'',
    telephoneSalon:'',
    adresse:'',
    cardLoyalty:'',
    countCardLoyalty:'',
    horaires:'',
    facebook:'',
    instagram:'',
    twitter:'',
    googleMap:'',
}

const Profil = () => {
    const { user } = useContext(AppContext)
    const { readData, profil, updateData, count } = useFirebase()
    const { handleChange, values, setValues } = useForm(INITIAL_STATE)
    const [montage, setMontage] = useState(true)

    useEffect(() => {
        readData(user.uid)
        window.scrollTo(0, 0)
        setMontage(false)
    },[])

    useEffect(() => {
        if (profil) {
            profil.filter(p => p.id === 'profil').map(p => (
                setValues(prev => ({
                    ...prev,
                    nomEntreprise:p.nomEntreprise,
                    telephoneEntreprise:p.telephoneEntreprise,
                    telephoneSalon:p.telephoneSalon,
                    adresse:p.adresse,
                    horaires:p.horaires,
                    facebook:p.facebook,
                    instagram:p.instagram,
                    twitter:p.twitter,
                    googleMap:p.googleMap,
                    cardLoyalty:p.cardLoyalty ? p.cardLoyalty : false,
                    countCardLoyalty:p.countCardLoyalty ? p.countCardLoyalty : 10,
                }))
            ))
        }
    },[profil])

    if (montage) return <Spinner />

    const handleBox = () => {
        const data = {
            cardLoyalty:!values.cardLoyalty
        }
        updateData('entreprises/'+user.uid+'/profil/',data)
    }

    const _updateProfil = () => {
        const data = { 
            nomEntreprise:values.nomEntreprise ? values.nomEntreprise : '',
            telephoneEntreprise:values.telephoneEntreprise ? values.telephoneEntreprise : '',
            telephoneSalon:values.telephoneSalon ? values.telephoneSalon : '',
            adresse:values.adresse ? values.adresse : '',
            cardLoyalty:values.cardLoyalty ? values.cardLoyalty : '',
            countCardLoyalty:values.countCardLoyalty ? values.countCardLoyalty : '',
            horaires:values.horaires ? values.horaires : '',
            facebook:values.facebook ? values.facebook : '',
            instagram:values.instagram ? values.instagram : '',
            twitter:values.twitter ? values.twitter : '',
            googleMap:values.googleMap ? values.googleMap : '',
        }
        updateData('entreprises/'+user.uid+'/profil/',data)
    }



    return (
        <div className='container-fluid'>

            <HeaderReturn title='Profil' image={imageProfil} link='/homeServeur'/>

            {profil && profil.filter(p => p.id === 'profil').map(p => (
                <div key={p.id}>

                    {/* NOM ENTREPRISE */}
                    <div className="mb-3 mx-1 mt-3 text-center">
                        <label className="form-label">Nom entreprise</label>
                        <input type="text" onChange={handleChange} className="form-control border-0 rounded-pill shadow p-2" placeholder="Nom entreprise"  name='nomEntreprise' value={values.nomEntreprise}  />
                    </div>

                    {/* TELEPHONE ENTREPRISE */}
                    <div className="mb-3 mx-1 text-center">
                        <label className="form-label">Téléphone entreprise</label>
                        <input type="number" onChange={handleChange} className="form-control border-0  rounded-pill shadow p-2" placeholder="Téléphone entreprise"  name='telephoneEntreprise' value={values.telephoneEntreprise}  />
                    </div>

                    {/* TELEPHONE SALON */}
                    <div className="mb-3 mx-1 text-center">
                        <label className="form-label">Téléphone salon</label>
                        <input type="number" onChange={handleChange} className="form-control border-0  rounded-pill shadow p-2" placeholder="Téléphone salon"  name='telephoneSalon' value={values.telephoneSalon}  />
                    </div>

                    {/* ADRESSE */}
                    <div className="mb-3 mx-1 text-center">
                        <label className="form-label">Adresse</label>
                        <textarea className="form-control border-0 rounded shadow p-2" style={{resize:'none'}} onChange={handleChange}  name='adresse' rows="3" value={values.adresse}></textarea>
                    </div>

                    {/* HORAIRES */}
                    <div className="mb-3 mx-1 text-center">
                        <label className="form-label">Horaires</label>
                        <textarea className="form-control border-0 rounded shadow p-2" style={{resize:'none'}} onChange={handleChange}  name='horaires' rows="4" value={values.horaires}></textarea>
                    </div>

                    {/* FACEBOOK */}
                    <div className="mb-3 mx-1 mt-3 text-center">
                        <label className="form-label">Facebook</label>
                        <input type="text" onChange={handleChange} className="form-control border-0 rounded-pill shadow p-2" placeholder="Facebook"  name='facebook' value={values.facebook}  />
                    </div>

                    {/* INSTAGRAM */}
                    <div className="mb-3 mx-1 mt-3 text-center">
                        <label className="form-label">Instagram</label>
                        <input type="text" onChange={handleChange} className="form-control border-0 rounded-pill shadow p-2" placeholder="Instagram"  name='instagram' value={values.instagram}  />
                    </div>

                    {/* TWITTER */}
                    <div className="mb-3 mx-1 mt-3 text-center">
                        <label className="form-label">Twitter</label>
                        <input type="text" onChange={handleChange} className="form-control border-0 rounded-pill shadow p-2" placeholder="Twitter"  name='twitter' value={values.twitter}  />
                    </div>

                    {/* GOOGLE MAP */}
                    <div className="mb-3 mx-1 mt-3 text-center">
                        <label className="form-label">Google map</label>
                        <input type="text" onChange={handleChange} className="form-control border-0 rounded-pill shadow p-2" placeholder="Goole map"  name='googleMap' value={values.googleMap}  />
                    </div>
                    
                    {/* CARTE DE FIDELITE */}
                    {profil.filter(p => p.id === 'profil').map(p => (
                        <div key={p.id}>
                    <div className="mb-3 mx-1">
                        
                            <div>Email : {p.email}</div>
                        
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value={values.cardLoyalty} checked={values.cardLoyalty} onChange={handleBox} />
                        <label className="form-check-label" for="flexCheckDefault">
                            Carte de fidélité
                        </label>
                    </div>
                    {values.cardLoyalty === true &&
                        <div className="mb-3 mx-1 text-center">
                            <label className="form-label">Nombre de services</label>
                            <input type="number" onChange={handleChange} className="form-control border-0  rounded-pill shadow p-2" placeholder="Nombre de services"  name='countCardLoyalty' value={values.countCardLoyalty}  />
                        </div>
                    }
                    </div>
                    ))}
                </div>
            
            ))}

            {/* BUTTON SAVE */}
            <ButtonShadow
                title='Enregistrer'
                onClick={() => _updateProfil()}
            />
        </div>
    )
}

export default Profil